import * as firebase from "firebase";
import * as compress from "./compress";
import {Point} from "./geometry";
import {User, ProjectListProject} from "./models";

const config = {
  apiKey: "AIzaSyA58ZYxnK0eb41PCvqJWAC3suMLcnA-AvM",
  authDomain: "textik-48365.firebaseapp.com",
  databaseURL: "https://textik-48365.firebaseio.com",
  storageBucket: "textik-48365.appspot.com",
  messagingSenderId: "636072371544"
};

interface ProjectState {
  completed: Object[];
}

firebase.initializeApp(config);
const database = firebase.database();
const provider = new firebase.auth.GoogleAuthProvider();
export const auth = firebase.auth();

declare type PathValue = string | PathArray;

interface PathArray extends Array<PathValue> { }

function path(...rest: PathValue[]): string {
  const args = rest[0] instanceof Array
      ? rest[0]
      : Array.prototype.slice.call(rest);
  return args.map((a) => {
    return a.toString().replace(/^\//, "").replace(/\/$/, "");
  }).join("/");
}

export function getProject(id: string): firebase.Promise<ProjectState | null> {
  if (database) {
    return database.ref(path("projects", id, "state")).once("value").then((data) => {
      if (data != null && data.val() != null) {
        return JSON.parse(compress.decompress(data.val()));
      } else {
        return null;
      }
    });
  } else {
    return Promise.resolve(null);
  }
}

export function authenticate(): firebase.Promise<{credential: firebase.auth.AuthCredential, user: firebase.User}> {
  return auth.signInWithPopup(provider);
}

export function updateUser(user: User): firebase.Promise<null> {
  if (database) {
    return database.ref(path("users", user.uid)).once("value").then((data) => {
      if (data == null || data.val() == null) {
        return database.ref(path("users", user.uid)).set(user);
      } else {
        return Promise.resolve(null);
      }
    });
  } else {
    return Promise.resolve(null);
  }
}

export function logOut(): firebase.Promise<void> {
  return auth.signOut();
}

export function shareCoordinates(id: string, uid: string, coords: Point): firebase.Promise<null> {
  if (database) {
    return database.ref(path("projects", id, "coordinates", uid)).set(coords);
  } else {
    return Promise.resolve(null);
  }
}

export function listenToCoordinates(
    id: string,
    callback: (a: firebase.database.DataSnapshot, b?: string) => void
): void {
  if (database) {
    database.ref(path("projects", id, "coordinates")).on("value", callback);
  }
}

export function getProjectList(user: User): firebase.Promise<ProjectListProject[] | null> {
  return database.ref(path("users", user.uid, "projects")).once("value").then((value) => {
    const projectPromises = Object.keys((value && value.val()) || []).map((id) => {
      return database.ref(path("projects", id)).once("value").then((data) => {
        if (data != null && data.val() != null) {
          const project = data.val();
          const state = JSON.parse(compress.decompress(project.state));
          return {
            id: id,
            state: state,
            name: project.name
          };
        } else {
          return null;
        }
      });
    });
    return Promise.all(projectPromises);
  });
}

export function saveProject(
    user: User,
    id: string,
    state: Object,
    projectName: string,
    callback: (a: Object | null) => void
): firebase.Promise<null> {
  if (database) {
    const saveState = database
      .ref(path("projects", id, "state"))
      .set(compress.compress(JSON.stringify(state)), callback);
    const projectNamePromise = database
      .ref(path("projects", id, "name"))
      .set(projectName);
    let assignToUser;
    if (user && !user.isGuest) {
      assignToUser = database.ref(path("users", user.uid, "projects", id)).set(true);
    } else {
      assignToUser = Promise.resolve(null);
    }
    return Promise.all([saveState, projectNamePromise, assignToUser]).then((_) => null);
  } else {
    return Promise.resolve(null);
  }
}

export function deleteProject(user: User, projectId: string): firebase.Promise<null> {
  const removePromise = database.ref(path("projects", projectId)).remove();
  let removeFromUserPromise;
  if (user && !user.isGuest) {
    removeFromUserPromise = database.ref(path("users", user.uid, "projects", projectId)).remove();
  } else {
    removeFromUserPromise = Promise.resolve(null);
  }
  return Promise.all([removePromise, removeFromUserPromise]).then((_) => null);
}

export function listenToProject(id: string, callback: (a: firebase.database.DataSnapshot, b?: string) => void): void {
  if (database) {
    database.ref(path("projects", id, "state")).on("value", callback);
  }
}

export function registerConnection(id: string, uid: string): firebase.Promise<null> {
  if (database) {
    return database.ref(path("projects", id, "connections")).push(uid).then((ref) => {
      ref.onDisconnect().remove();
    }).then((_) => null);
  } else {
    return Promise.resolve(null);
  }
}

export function listenToConnections(
    id: string,
    callback: (a: firebase.database.DataSnapshot, b?: string) => void
): void {
  if (database) {
    database.ref(path("projects", id, "connections")).on("value", callback);
  }
}



// WEBPACK FOOTER //
// ./assets/js/store.ts


// WEBPACK FOOTER //
// ./assets/js/store.ts